import { useContext } from 'react';

import { AuthContext } from '@arrived/auth';
import { OfferingId, TotalAvailableSharesResponse } from '@arrived/models';

import { UseQueryOptions } from '../queries.utils';
import { useGetPrimaryAccountQuery } from '../users';
import { useSharesAvailableForAccountQuery } from './useSharesAvailableForAccountQuery';
import { useSharesAvailableForUserQuery } from './useSharesAvailableForUserQuery';

/**
 * Indicates how many shares of an Offering are available to the current user.
 */
export function useSharesAvailableQuery(
  offeringId?: OfferingId,
  options?: UseQueryOptions<TotalAvailableSharesResponse>
) {
  const { isAuthenticated } = useContext(AuthContext);

  const accountState = useGetPrimaryAccountQuery({ enabled: isAuthenticated });

  const sharesAvailableForAccountState = useSharesAvailableForAccountQuery(offeringId, {
    ...options,
    enabled: (options?.enabled ?? true) && isAuthenticated,
  });

  const sharesAvailableForUserState = useSharesAvailableForUserQuery(offeringId, {
    ...options,
    enabled:
      (options?.enabled ?? true) && isAuthenticated && accountState.isError && accountState.error?.status === 404,
  });

  if (accountState.isError && accountState.error?.status === 404) {
    return sharesAvailableForUserState;
  }

  return sharesAvailableForAccountState;
}
